import { render, staticRenderFns } from "./CaseDashboard.vue?vue&type=template&id=22c48d82&"
import script from "./CaseDashboard.vue?vue&type=script&lang=js&"
export * from "./CaseDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports